var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a-audit{stroke-width:1.8px;}.b-audit{stroke:none;}.c-audit{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-27 -395)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a-audit",
    transform: "translate(39 400)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b-audit",
    d: "M0,0H6A2,2,0,0,1,8,2V16a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c-audit",
    d: "M1.8.9H6A1.1,1.1,0,0,1,7.1,2V14.2a.9.9,0,0,1-.9.9H1.8a.9.9,0,0,1-.9-.9V1.8A.9.9,0,0,1,1.8.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a-audit",
    transform: "translate(27 404)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b-audit",
    d: "M2,0H9A0,0,0,0,1,9,0V12a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2A2,2,0,0,1,2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c-audit",
    d: "M2,.9H7.2a.9.9,0,0,1,.9.9v8.4a.9.9,0,0,1-.9.9H1.8a.9.9,0,0,1-.9-.9V2A1.1,1.1,0,0,1,2,.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a-audit",
    transform: "translate(33 395)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b-audit",
    d: "M2,0H6A2,2,0,0,1,8,2V21a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2A2,2,0,0,1,2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c-audit",
    d: "M2,.9H6A1.1,1.1,0,0,1,7.1,2V19.2a.9.9,0,0,1-.9.9H1.8a.9.9,0,0,1-.9-.9V2A1.1,1.1,0,0,1,2,.9Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudit);
export default __webpack_public_path__ + "static/media/audit.98f78991413929f97ae2e119d2d30ed5.svg";
export { ForwardRef as ReactComponent };